import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import {
  CheckboxGroupField,
  CheckboxGroupFieldProps,
} from 'components/checkbox-group-field/checkbox-group-field';
import { pick } from 'utils/pick';

type FormItemCheckboxGroupFieldProps = Omit<
  CheckboxGroupFieldProps,
  'value' | 'onChange'
>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: {
      color: theme.palette.error.main,
      fontWeight: 'normal',
      height: '2em',
    },
  })
);

export function FormItemCheckboxGroupField(
  props: FormItemCheckboxGroupFieldProps
) {
  const classes = useStyles();

  type TValue = string[];

  const [field, meta, helpers] = useField<string[]>(props.name);

  const value: TValue = field.value || [];

  const handleChange = useCallback(
    (value: TValue) => {
      helpers.setValue(value);
    },
    [helpers]
  );

  const innerProps = pick(props, 'label', 'name', 'items');

  return (
    <>
      <div className={classes.error}>{meta.error}</div>
      <CheckboxGroupField
        value={value}
        onChange={handleChange}
        {...innerProps}
      />
    </>
  );
}
